import { render, staticRenderFns } from "./r-table.vue?vue&type=template&id=43a81130&"
import script from "./r-table.vue?vue&type=script&lang=js&"
export * from "./r-table.vue?vue&type=script&lang=js&"
import style0 from "./r-table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports